import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedRightFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M7.66 10.46C7.66 12.4 9.16 13.96 11.04 13.96H15.88L11.7 9.84L12.98 8.56L19.34 14.92L12.98 21.28L11.7 20L15.88 15.88H11.04C7.98 15.88 5.66 13.52 5.66 10.46V4.92H7.66V10.46Z" />
    </SvgIcon>
  );
});
